import {
  EstadosPreagendamientoEnumChoice,
  gridSizeMdLg12,
  gridSizeMdLg6,
  handleErrorForm,
  ModulosEnumChoice,
  solicitudTecnicoFormSchema,
  texto,
} from "@/shared";
import { useUpdateAgendamiento } from "@/shared/actions/erp";
import {
  CustomAutocomplete,
  CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  LoaderComponent,
  SingleTableBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { Agendamiento, Flota } from "@/shared/interfaces";
import { useFlotasStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Grid } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useModalRechazoSolicitudTecnico } from "../../hook/useModalRechazoSolicitudTecnico";

interface IFormSolicitudTecnico {
  flota_adicional: string;
}

interface SaveSolicitudTecnicoAgendaPymesProps {
  title: string;
  agendamiento: Agendamiento;
  router_path: string;
}

export default function SaveSolicitudTecnicoAgendaPymes({
  title,
  agendamiento,
  router_path,
}: SaveSolicitudTecnicoAgendaPymesProps) {
  const form = useForm<IFormSolicitudTecnico>({
    resolver: yupResolver(solicitudTecnicoFormSchema),
  });

  const navigate = useNavigate();

  ///* store
  const { flotas, isLoadingFlotas, getFlotas } = useFlotasStore();

  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const useHookModalMotivoRechazo = useModalRechazoSolicitudTecnico({
    modulo: ModulosEnumChoice.AGENDAMIENTO,
    returnUrl: router_path,
  });

  ///* react query

  const { mutateAsync } = useUpdateAgendamiento({
    navigate,
    returnUrl: router_path,
  });

  useEffect(() => {
    getFlotas({
      //es_corporativo: true
    });
    return () => {};
  }, []);

  if (isLoadingFlotas) {
    return <LoaderComponent />;
  }

  return (
    <>
      <SingleTableBoxScene
        title={title}
        enableBackBtn={true}
        backPageUrl={router_path}
        py={3}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Aprobar"
        iconCreateOrEdit={<CheckCircleIcon />}
        fnCreateOrEdit={form.handleSubmit(
          () => {
            setConfirmDialogIsOpen(true);

            setConfirmDialog({
              isOpen: true,
              title: "Confirmar",
              subtitle:
                "La solicitud de técnico esta por ser aprobada. ¿Estás seguro? Este cambio es irreversible.",
              confirmTextBtn: "Si",
              onConfirm: async () => {
                try {
                  if (!agendamiento.id_agendamiento) return;

                  await mutateAsync({
                    id: agendamiento.id_agendamiento,
                    data: {
                      estado_agendamiento:
                        EstadosPreagendamientoEnumChoice.FINALIZADO,
                      solicitar_tecnico: false,
                      flota_adicional: form.getValues().flota_adicional,
                    },
                  });
                } catch (error) {
                } finally {
                  setConfirmDialogIsOpen(false);
                }
              },
              onClose: () => {
                setConfirmDialogIsOpen(false);
              },
            });
          },
          (error) => {
            handleErrorForm(error);
          },
        )}
        enableAccionBtn={true}
        fnAccionBtn={() => {
          ///* rechazar
          useHookModalMotivoRechazo.setDialogContentText(
            `Estás a punto de rechazar una solicitud de técnico. ¿Estás seguro? Este cambio es irreversible.`,
          );
          useHookModalMotivoRechazo.setModalCancelar(true);
          useHookModalMotivoRechazo.reset({
            id: agendamiento.id_agendamiento,
            observaciones: agendamiento.observaciones,
          });
        }}
      >
        <Box
          sx={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <Grid container spacing={3} width={"80%"}>
            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Información Cliente"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={"Razon Social Empresa"}
              defaultValue={agendamiento.prospecto_data?.razon_social}
              size={gridSizeMdLg12}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.direccion}
              defaultValue={agendamiento.preventa_data?.direccion}
              size={gridSizeMdLg12}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel text={"Servicio"} pt={0} mt={0} pb={0} pl={0} />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={"Tipo Servicio"}
              defaultValue={agendamiento.preventa_data?.tipo_servicio}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={"Bw Inicial"}
              defaultValue={agendamiento.preventa_data?.velocidad}
              size={gridSizeMdLg6}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Localidad Servicio"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.coordenadas}
              defaultValue={agendamiento.preventa_data?.coordenadas}
              size={gridSizeMdLg12}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.provincia}
              defaultValue={agendamiento?.provincia_data?.nombre}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.city}
              defaultValue={agendamiento?.ciudad_data?.nombre}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.zona}
              defaultValue={agendamiento?.zona_data_nombre}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.sector}
              defaultValue={agendamiento?.sector_data?.nombre}
              size={gridSizeMdLg6}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Información de Solicitud"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            <CustomTextAreaNoForm
              disabled={true}
              label={`Información`}
              value={
                agendamiento?.observaciones?.observacion_tecnico_adicional ??
                "N/A"
              }
              defaultValue={
                agendamiento?.observaciones?.observacion_tecnico_adicional ??
                "N/A"
              }
              size={gridSizeMdLg12}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Asignar Técnico"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            <CustomAutocomplete<Flota>
              disabled={false}
              size={gridSizeMdLg12}
              label={"Técnicos Disponibles"}
              name="flota_adicional"
              options={flotas || []}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().flota_adicional}
              isLoadingData={isLoadingFlotas}
              control={form.control}
              error={form.formState.errors.flota_adicional}
              helperText={form.formState.errors.flota_adicional?.message}
              onChangeValue={(e) => {
                form.setValue("flota_adicional", e);
              }}
            />
          </Grid>
        </Box>
      </SingleTableBoxScene>

      <ModalMotivoRechazo {...useHookModalMotivoRechazo} />
    </>
  );
}
